import React from 'react';
import { Link } from 'react-router-dom';

import { Layout, Menu } from 'antd';
const { Header, Content } = Layout;

import logo from 'images/SAS-seal-rev.png';

export default class App extends React.Component {
	state = {
		blue: '#0b3753'
	}
	setBlue = () => {
		let blue = '';
		switch (window.location.host) {
			case 'admin.semesteratsea.org': blue = '#0b3753'; break;
			case 'testingadmin.semesteratsea.org': blue = '#ff6666'; break;
			case 'stagingadmin.semesteratsea.org':
			default:
				blue = '#ae87bc';
				break;
		}
		this.setState({ blue: blue });
		document.body.style.backgroundColor = blue;
	}
	componentDidMount() { this.setBlue(); }
	componentWillReceiveProps() { this.setBlue(); }
	render() {
		const showMenu = window.location.hash !== '#/';
		return (
			<Layout>
				<Header style={{background: this.state.blue, padding: '8pt 0 4pt 16pt', minHeight: '90px', height: 'auto'}}>
					<img style={{maxHeight: '60px'}} src={logo} alt="logo" />
					<span className="logoTitle">My&nbsp;Voyage</span>
					{showMenu &&
						<Menu mode="horizontal" style={{background: this.state.blue, float:'right'}}>
							{[
								// {name: 'Home', path: '/portal'},
								{name: 'Manage Travelers', path: '/portal'},
								{name: 'Manage Field Programs', path: '/portal/fieldadmin'},
								{name: 'Log out', path: '/'},
								// {name: 'Change Password', path: '/account'},
								// {name: 'Contact Us', path: '/contact'}
							].map(item => {
								return ( 
									<Menu.Item key={item.name}>
										<Link to={item.path} style={{color:'white'}}>
											{item.name}
										</Link>
									</Menu.Item>
								);
							})}
						</Menu>
					}
					
				</Header>
				<Content>
					{this.props.children}
				</Content>
			</Layout>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/App/index.jsx